import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from 'antd';
import {
  pushPermission,
  removePermission,
} from '@ohif/viewer/src/store/permission/actions';
import useSearchParams from '@ohif/viewer/src/customHooks/useSearchParams';
import * as api from './api';
import './index.less';

const useGetMenu = id => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    api
      .getMenu({ id })
      .then(res => setItems(res.list || []))
      .finally(() => setLoading(false));
  }, [id]);
  return [items, loading];
};

const Navigation = ({ id, onChange }) => {
  const history = useHistory();
  const location = useLocation();
  const [items, loading] = useGetMenu(id);

  const [searchParams, joinSearch] = useSearchParams();
  const splitUrl = url => (url || '').split('?');
  const isUrl = useCallback(
    url => {
      const [pathname, search] = splitUrl(url);
      let isSearch = search || !searchParams['type'];
      if (search) {
        const [key, value] = search.split('=');
        isSearch = searchParams[key] === value;
      }
      return pathname === location.pathname && isSearch;
    },
    [location.pathname, searchParams]
  );

  const handleGo = useCallback(
    data => e => {
      e.preventDefault();
      e.stopPropagation();
      const [pathname, search] = splitUrl(data.url);
      if (search) {
        const [key, value] = search.split('=');
        searchParams[key] = value;
      } else delete searchParams['type'];
      if (history.action === 'REPLACE') {
        delete searchParams['markTaskPageSize'];
        delete searchParams['markTaskPage'];
      }
      history.push({
        pathname,
        search: joinSearch(searchParams),
      });
      onChange && onChange(data);
    },
    [history, joinSearch, onChange, searchParams]
  );

  // 权限获取
  const dispatch = useDispatch();
  useEffect(() => {
    if (!id) return;
    const menu = items.find(item => item.code === 'MU0203');
    if (!menu) return;
    const permissions = [];
    items.some(item => {
      if (item.code === 'MU0217') {
        permissions.push({ menu: menu.url, action: item.code, data: id });
        return true;
      }
    });
    permissions.forEach(item => dispatch(pushPermission(item)));
    return () => permissions.forEach(item => dispatch(removePermission(item)));
  }, [dispatch, id, items]);

  useEffect(() => {
    if (loading) return;
    // 当前路由不在导航菜单中跳转到科研首页
    !items.some(item => isUrl(item.url)) &&
      location.pathname !== '/research' &&
      history.replace({ pathname: '/research', search: location.search });
  }, [history, isUrl, items, loading, location.pathname, location.search]);

  return (
    <div className="navigation">
      {items.map((item, index) => (
        <Button
          key={index}
          type={isUrl(item.url) ? 'primary' : 'default'}
          onClick={handleGo(item)}
        >
          {item.name}
        </Button>
      ))}
    </div>
  );
};

Navigation.propTypes = {
  id: PropTypes.number,
  onChange: PropTypes.func,
};

export default Navigation;
